var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 9,
    fill: "#0066FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 37C24.811 37 26.326 35.709 26.674 34H19.326C19.674 35.709 21.189 37 23 37Z",
    fill: "#F5F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.576 27.496C30.55 27.496 30.526 27.5 30.5 27.5C26.089 27.5 22.5 23.911 22.5 19.5C22.5 17.767 23.06 16.166 24 14.854V14C24 13.447 23.552 13 23 13C22.448 13 22 13.447 22 14V15.08C18.613 15.568 16 18.481 16 22V24.788C16 26.767 15.133 28.635 13.612 29.921C13.223 30.254 13 30.738 13 31.25C13 32.215 13.785 33 14.75 33H31.25C32.215 33 33 32.215 33 31.25C33 30.738 32.777 30.254 32.378 29.913C31.59 29.246 30.982 28.416 30.576 27.496Z",
    fill: "#F5F9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.5C24 15.916 26.916 13 30.5 13C34.084 13 37 15.916 37 19.5C37 23.084 34.084 26 30.5 26C26.916 26 24 23.084 24 19.5ZM30.75 22.5C31.164 22.5 31.5 22.164 31.5 21.75V17.75C31.5 17.336 31.164 17 30.75 17H29.5C29.086 17 28.75 17.336 28.75 17.75C28.75 18.164 29.086 18.5 29.5 18.5H30V21.75C30 22.164 30.336 22.5 30.75 22.5Z",
    fill: "#F5F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepStep3);
export default __webpack_public_path__ + "static/media/step-step-3.6dd0dd115d771f6c62993743a340d55f.svg";
export { ForwardRef as ReactComponent };